import Icon from '../components/Icon.vue'

Icon.register({
  vial: {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M477.7 186.1c3.1 3.1 3.1 8.2 0 11.2l-34 33.9c-3.1 3.1-8.2 3.1-11.3 0l-11.2-11.1-246.3 245.7c-20.1 20.1-46.5 30.1-72.9 30.1-28.9 0.1-57.8-11.9-78.4-35.9-35.7-41.5-29.4-104.8 9.4-143.5l242.4-241.9-11.2-11.1c-3.1-3.1-3.1-8.2 0-11.3l34-33.9c3.1-3.1 8.2-3.1 11.3 0zM318 256l69.5-69.4-78.5-78.3-148 147.7h157z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vial.js
// module id = 2088
// module chunks = 0